/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown>, action: NonNullable<unknown> }} Seo_Endpoint_Q_CostInputs */

const en_seo_endpoint_q_cost = /** @type {(inputs: Seo_Endpoint_Q_CostInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`How much does the ${i?.name} ${i?.action} API cost?`)
};

const zh_hans1_seo_endpoint_q_cost = /** @type {(inputs: Seo_Endpoint_Q_CostInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} ${i?.action} API 怎么收费？`)
};

const pt_br2_seo_endpoint_q_cost = /** @type {(inputs: Seo_Endpoint_Q_CostInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Quanto custa o endpoint ${i?.action} da API para ${i?.name}?`)
};

const es_seo_endpoint_q_cost = /** @type {(inputs: Seo_Endpoint_Q_CostInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`¿Cuánto cuesta el endpoint ${i?.action} de la API de ${i?.name}?`)
};

const fr_seo_endpoint_q_cost = /** @type {(inputs: Seo_Endpoint_Q_CostInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Combien coûte l’API ${i?.name} ${i?.action} ?`)
};

const de_seo_endpoint_q_cost = /** @type {(inputs: Seo_Endpoint_Q_CostInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Was kostet die ${i?.name}-${i?.action}-API?`)
};

const ru_seo_endpoint_q_cost = /** @type {(inputs: Seo_Endpoint_Q_CostInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Сколько стоит API ${i?.name} ${i?.action}?`)
};

const it_seo_endpoint_q_cost = /** @type {(inputs: Seo_Endpoint_Q_CostInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Quanto costa l'API ${i?.name} ${i?.action}?`)
};

/**
* | output |
* | --- |
* | "How much does the {name} {action} API cost?" |
*
* @param {Seo_Endpoint_Q_CostInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const seo_endpoint_q_cost = /** @type {((inputs: Seo_Endpoint_Q_CostInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_Endpoint_Q_CostInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_seo_endpoint_q_cost(inputs)
	if (locale === "pt-BR") return pt_br2_seo_endpoint_q_cost(inputs)
	if (locale === "es") return es_seo_endpoint_q_cost(inputs)
	if (locale === "fr") return fr_seo_endpoint_q_cost(inputs)
	if (locale === "de") return de_seo_endpoint_q_cost(inputs)
	if (locale === "ru") return ru_seo_endpoint_q_cost(inputs)
	if (locale === "it") return it_seo_endpoint_q_cost(inputs)
	return en_seo_endpoint_q_cost(inputs)
});